













import Vue from 'vue'
import BaseModal from 'vuecomponents/base_modal.vue'
import { mapState, mapActions } from 'vuex'

export default Vue.extend({
  components: {
    BaseModal,
  },
  computed: {
    ...mapState('confirmationDialog', ['isOpen', 'title', 'body', 'confirmButtonText', 'cancelButtonText']),
  },
  methods: {
    ...mapActions('confirmationDialog', ['cancel', 'confirm']),
  },
})
